module.exports = __webpack_public_path__ + "static/freakonomics-78ce0002a40b082fd7735c9db0896220.jpg";